<template>
  <v-chip
    v-if="ActivityStatus__c[value] && ActivityStatus__c[value].labelClass"
    :class="ActivityStatus__c[value].labelClass"
    small
  >
    {{ value }}
  </v-chip>
  <span v-else>{{ value }}</span>
</template>

<script>
import { ActivityStatus__c } from '@/assets/js/objects/CDS_T_DamageReport__c';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    ActivityStatus__c,
  }),
};
</script>
